export default __webpack_public_path__ + "static/media/Group1322.ee3bc712.svg";